import { authenticationService } from '@/services/authentication_service';
// import eventTracker, { EventType } from '@/Services/eventTracker';
import * as profileActions from '@/store/modules/myAccount';
import dynamic from 'next/dynamic';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    CitySearchProfileWrapper,
    MenuLogoHeaderWrapper,
    Wrapper,
} from './styles';
import useProfileData from '@/hooks/useProfileData';

const Logout = dynamic(() => import('./Logout'), { ssr: false });
const ProfileMenu = dynamic(() => import('./ProfileMenu'), {
    ssr: false,
});
const ProfileMobile = dynamic(() => import('./ProfileMobile'));
const ADNewLogo = dynamic(() => import('./ADNewLogo'));
const HamBurgerMenu = dynamic(() => import('./hamBurgerMenu'));

export interface IMenuItem {
    title: string;
    url: string | null;
    isActive?: boolean;
    icon?: React.ReactNode;
    backgroundcolor?: string;
    eventName?: string;
    collectioName?: string;
}

export interface IMenuProps {
    menuItems?: IMenuItem[];
    menuItemsGap: string;
    menuFontSize: string;
    menuFontWeight: string;
    menuLineHeight: string;
}

interface INewHeaderProps {
    hideHamburgerMenu?: boolean;
    hideHeaderLogo?: boolean;
    hideLogin?: boolean;
    isMobileDevice?: boolean;
    hideShadow?: boolean;
}

export default function AdHeader({
    isMobileDevice,
    hideHeaderLogo,
    hideHamburgerMenu,
    hideLogin,
    hideShadow,
}: INewHeaderProps) {
    const ismobile: any = isMobileDevice;
    const [isLogoutModalVisible, setIsLogoutModalVisible] =
        useState<boolean>(false);
    const dispatch = useDispatch();
    const [isProfileOptionsVisible, setIsProfileOptionsVisible] =
        useState<boolean>(false);
    const [scrollShadow, setScrollShadow] = useState<boolean>(false);
    const userInitials = useProfileData();
    const { state } = useSelector((state: any) => ({
        state: state,
    }));

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0 && !hideShadow) {
                setScrollShadow(true);
            } else {
                setScrollShadow(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleClickOutside = useCallback((event: any) => {
        const getClosest = function (elem: any, selector: any) {
            for (; elem && elem !== document; elem = elem.parentNode) {
                if (elem.matches(selector)) return elem;
            }
            return null;
        };
        if (
            event.target.id !== 'profileEdit' &&
            !getClosest(event.target, '#profileEdit')
        ) {
            setIsProfileOptionsVisible(false);
        }
    }, []);

    const toggleProfileOptions = () => {
        setIsProfileOptionsVisible((prev) => !prev);
    };

    const toggleLogoutModal = () => {
        if (!isLogoutModalVisible) {
            // eventTracker.pushEvent('tap_btn_logout', EventType.TRACK_EVENT);
        } else {
            // eventTracker.pushEvent(
            //     'tap_btn_logout_popup',
            //     EventType.TRACK_EVENT,
            //     {
            //         logout: 'No',
            //     }
            // );
        }
        setIsLogoutModalVisible((prev) => !prev);
    };

    const renderProfileMenuOrOptions = () => {
        if (isProfileOptionsVisible) {
            return (
                <ProfileMenu onClose={() => {}} onLogout={toggleLogoutModal} />
            );
        }
        return null;
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    console.log('state', state);
    return (
        <>
            <Wrapper isMobile={ismobile} scrollShadow={scrollShadow}>
                <MenuLogoHeaderWrapper isMobile={ismobile}>
                    {!hideHamburgerMenu && (
                        <HamBurgerMenu toggleLogoutModal={toggleLogoutModal} />
                    )}
                    {!hideHeaderLogo && <ADNewLogo isMobile={ismobile} />}
                </MenuLogoHeaderWrapper>

                <CitySearchProfileWrapper isMobile={ismobile}>
                    {!hideLogin && (
                        <ProfileMobile
                            toggleProfileOptions={toggleProfileOptions}
                            refid="profileEdit"
                        />
                    )}
                </CitySearchProfileWrapper>
            </Wrapper>
            {authenticationService.isLoggedIn() && (
                <>
                    {renderProfileMenuOrOptions()}
                    {isLogoutModalVisible && (
                        <Logout
                            toggleLogoutModal={toggleLogoutModal}
                            clearProfileData={() => {
                                dispatch(profileActions?.clearProfileData());
                            }}
                        />
                    )}
                </>
            )}
        </>
    );
}
